import styled, { css } from 'styled-components/macro';

export const TabH5 = styled.h5`
  padding: 0.8rem 0.8rem;
  color: ${props => props.theme.dustierGray};
  &:hover {
    color: black;
  }
  white-space: nowrap;
  position: relative;
  ${props =>
    props.active &&
    css`
      color: black;
    `}
  ${props =>
    props.disabled &&
    css`
      text-decoration: line-through;
    `}
  @media screen and (max-width: 767px) {
    flex-grow: 1;
    text-align: center;
    border-bottom: 2px solid transparent;
    ${props =>
      props.active &&
      css`
        border-bottom-color: black;
      `}
    ${props =>
      props.active &&
      props.mobileActiveBorderRight &&
      css`
        border-right: 2px solid transparent;
        border-right-color: black;
        margin-right: -1px;
      `}
  }
  @media screen and (min-width: 768px) {
    border-right: 2px solid transparent;
    padding: 1.8rem 0.8rem;
    margin-right: -1px;
    ${props =>
      props.active &&
      css`
        border-right-color: black;
      `}
  }
  svg {
    height: 1rem;
    margin-right: 0.3rem;
    @media screen and (min-width: 768px) {
      position: absolute;
      left: -1rem;
    }
  }
  ${props =>
    props.vertical &&
    css`
      @media screen and (max-width: 767px) {
        padding: 2.5rem 1.5rem;
      }
      @media screen and (min-width: 768px) {
        padding: 1.8rem 26px;
      }
    `}
`;

export const ProgressTabsDiv = styled.div`
  display: flex;
  position: relative;
  padding-top: 3rem;
  @media screen and (min-width: 768px) {
    padding-top: 0;
    flex-direction: column;
    border-right: ${props => props.theme.defaultBorder};
  }
  @media screen and (max-width: 767px) {
    border-bottom: 1px solid ${props => props.theme.mercury};
  }
`;
